<template lang="pug">
  #root
    #edit-time.modal(style="z-index:2000")
      .modal-background
      .modal-card
        .modal-card-body(v-if='time')
          TimeLog(v-if="time", :time="time")
          section(style="text-align:left")  
            .flex
              .flex-min(v-if="!time.approved") 
                button(style="margin:1rem", @click='save_edit_time', :disabled='!time.seconds').button.is-large.is-success Save
              .flex-min
                button(style="margin:1rem", @click='cancel_edit_time').button.is-large.is-light Cancel
                
              .flex-grow(style="text-align:right") 
                button(v-if='time._id && !time.approved', style="margin:1rem", @click='delete_time').button.is-large.is-danger Delete
          
    div#login(v-if="!user")
      .hero
        .hero-head
        .hero-body
          .container
            img.brand(src="/img/cp.png")
            h1.title WEEKLY TIME
            form
              .field
                input.input.is-large.is-fullwidth(v-model="pin", placeholder="Enter your PIN")
              div
                button(@click="login", type="button").button.is-primary.is-large.is-fullwidth Login
        .hero-foot
    div(v-else-if = "!company") 
      .card
        .card-content.warning
          .hero.is-vcentered
            .hero-head
            .hero-body
              .container
                .title(style="color:black", v-html="no_company_heading")
                p(v-html="no_company_message")
    
    div(v-else).content
      //- Hidden for Touch and below
      nav.flex.is-hidden-touch
        .flex-min.padded: CompanyPicker
        .flex-min.padded: CrewPicker
        .flex-min.padded: EmployeePicker
        .flex-grow.padded.text-right: WeekPicker
      //- Hidden for Above touch
      nav.is-hidden-desktop.columns.is-mobile
        .column
          .padded: CompanyPicker
          .padded: CrewPicker
          .padded: EmployeePicker
        .column
          .padded: WeekPicker
      div#week-grid
        .columns.is-mobile.week-heading#week-sticky
          .column.is-one-fifth
              h1 Task
          .column(v-if="weekends")
            span Sun
            br
            span {{day_of_week(0).format("MMM D")}}
          .column 
            span Mon
            br
            span {{day_of_week(1).format("MMM D")}}
          .column 
            span Tue
            br
            span {{day_of_week(2).format("MMM D")}}
          .column 
            span Wed
            br
            span {{day_of_week(3).format("MMM D")}}
          .column 
            span Thu
            br
            span {{day_of_week(4).format("MMM D")}}
          .column 
            span Fri
            br
            span {{day_of_week(5).format("MMM D")}}
          .column(v-if="weekends")
            span Sat
            br
            span {{day_of_week(6).format("MMM D")}}
          .column.is-hidden-touch
        div(v-for='task in tasks')
          TaskRow(:task='task', @confirm='confirm')
    footer.footer(v-if="user")
      .flex
        .flex-min(style="padding-right:1rem")
          button.button.is-success.is-large(@click='refresh')
            font-awesome-icon(icon='sync')
        .flex-min(style="padding-right:1rem")
          ClearPin
        //-.flex-min(style="padding-right:1rem")
          Language
        .flex-grow(style="text-align:right")
          button.button.is-large(:class="{'is-dark':weekends, 'is-light':!weekends}", @click='toggle_weekends')
            span Weekends
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import ClearPin from "@/components/ClearPin";
import Language from "@/components/Language";
import CompanyPicker from "@/components/CompanyPicker";
import CrewPicker from "@/components/CrewPicker";
import EmployeePicker from "@/components/EmployeePicker";
import WeekPicker from "@/components/WeekPicker";
import TaskRow from "@/components/TaskRow";
import LogService from "@/api/log";
import PinService from "@/api/pin";
import TimeLog from "@/components/TimeLog";
import moment from "moment";

export default {
  name: "weekly",
  data: function() {
    return {
      pin: null,
      offline: false,
      time: null
    };
  },
  components: {
    ClearPin,
    Language,
    CompanyPicker,
    CrewPicker,
    EmployeePicker,
    WeekPicker,
    TaskRow,
    TimeLog
  },
  computed: {
    ...mapState([
      "user",
      "crew",
      "company",
      "language",
      "companies",
      "tasks",
      "weekends",
      "next_start_time",
      "last_day_entered"
    ]),
    ...mapGetters([]),
    no_company_heading() {
      if (this.language == "en") return "No Access";
      else return "Sin acceso";
    },
    no_company_message() {
      if (this.language == "en")
        return "You must be a <b> foreman and crew leader</b> to use the app.";
      else return "Debes ser capataz y jefe de equipo para usar la aplicación.";
    }
  },
  mounted: function() {
    this.$store.state.bus.$on("edit-time", o => {
      if (o.time) {
        // Editing an existing time...
        this.time = o.time;
      } else {
        // creating a new time
        let start_time = this.next_start_time;
        if (o.day != this.last_day_entered) {
          start_time = {
            hr: "09",
            min: "00",
            ampm: "am"
          };
        }
        const start_time_string = `${o.day} ${start_time.hr}:${start_time.min}${start_time.ampm}`;
        const m = moment(start_time_string, "YYYY-MM-DD hh:mma");

        const time = {
          user: this.$store.state.employee,
          category: o.task.category,
          startTime: m.format("hh:mm"),
          approved: false,
          maintenance_codes: [],
          service_codes: [],
          paycodes: [],
          material_usage: [],
          equipment_usage: [],
          company: {
            _id: this.$store.state.company._id,
            name: this.$store.state.company.name
          },
          start: m.toDate(),
          state: "stopped",
          seconds: 0,
          notes: "",
          lineItem: o.task.category == "line-item" ? o.task._id : undefined,
          job: o.task.category == "line-item" ? o.task.job_id : undefined,
          equipment: o.task.category == "equipment" ? o.task._id : undefined,
          workorder: o.task.category == "workorder" ? o.task._id : undefined,
          task: o.task // not honored by CP4Cloud... will be populated when editing other times..
        };
        this.time = time;
      }
      this.open_time();
    });
    this.$store.subscribe((mutation, state) => {
      if (!state.user) {
        // Logged out, do nothing with local storage, as it shoudl have already been cleared.
        localStorage.clear();
        return;
      }

      // Store the serializable state in local storage in case page refresh
      // in offline environment.
      const serializable = {
        user: state.user,
        company: state.company,
        crew: state.crew,
        task: state.task,
        employee: state.employee,
        companies: state.companies,
        language: state.language,
        weekends: state.weekends
      };

      localStorage.setItem(
        `weekly-state-${this.pin}`,
        JSON.stringify(serializable)
      );

      switch (mutation.type) {
        case "login":
        case "company":
        case "load":
          this.load_addons();
        case "employee":
        case "crew":
        case "week_plus":
        case "week_minus":
          this.load_times();
          break;
        default:
          break;
      }
    });

    const stored_pin = localStorage.getItem("weekly-pin");
    if (stored_pin) this.pin = stored_pin;
    if (this.pin) {
      this.login();
    }
  },
  methods: {
    moment: function() {
      return moment();
    },
    toggle_weekends() {
      this.$store.commit("weekends", !this.$store.state.weekends);
    },
    day_of_week(offset) {
      const m = moment(this.$store.state.sunday);
      m.add(offset, "days");
      return m;
    },
    async open_time() {
      const response = await LogService.get_crafts(
        this.pin,
        this.$store.state.company,
        this.$store.state.employee
      );
      this.$store.commit("crafts", response.data);
      document.getElementById("edit-time").classList.add("is-active");
    },

    cancel_edit_time() {
      document.getElementById("edit-time").classList.remove("is-active");
    },
    async delete_time() {
      document.getElementById("edit-time").classList.remove("is-active");
      await LogService.delete(this.pin, this.time);
      this.load_times();
    },
    async save_edit_time() {
      document.getElementById("edit-time").classList.remove("is-active");

      for (const eq of this.time.equipment_usage) {
        if (eq.sync_with_task) {
          eq.seconds = this.time.seconds;
        }
      }
      this.time.confirmed = false;
      let m = moment(this.time.startTime, "HH:mm");
      m.add(this.time.seconds, "seconds");
      const s = {
        hr: m.format("hh"),
        min: m.format("mm"),
        ampm: m.format("a")
      };
      this.$store.commit("start_time", {
        day: moment(this.time.start).format("YYYY-MM-DD"),
        time: s
      });

      if (this.time.job && this.time.job._id) this.time.job = this.time.job._id;
      if (this.time.lineItem && this.time.lineItem._id)
        this.time.lineItem = this.time.lineItem._id;
      if (this.time.equipment && this.time.equipment._id)
        this.time.equipment = this.time.equipment._id;
      if (this.time.workorder && this.time.workorder._id)
        this.time.workorder = this.time.workorder._id;

      await LogService.put(this.pin, this.time);

      this.load_times();
    },
    async confirm(task) {
      const times = this.$store.getters.task_times(task);
      await LogService.confirm(
        this.pin,
        this.$store.state.company,
        times.map(t => t._id)
      );
      //this.$store.commit("refresh_crew", response.data);
      this.load_times();
    },

    load_addons: async function() {
      if (this.$store.state.company) {
        const response = await LogService.get_addons(
          this.pin,
          this.$store.state.company
        );
        this.$store.commit("addons", response.data);
      }
    },
    refresh: async function() {
      const response = await PinService.login(this.pin);
      this.$store.commit("refresh", response.data);
      await this.load_times();
    },
    load_times: async function() {
      // Get times for the current task list
      if (
        this.$store.state.company &&
        this.$store.state.tasks &&
        this.$store.state.employee &&
        this.$store.state.sunday
      ) {
        const start = moment(this.$store.state.sunday);
        const end = moment(this.$store.state.sunday);
        end.add(1, "w");
        const response = await LogService.get(
          this.pin,
          this.$store.state.company,
          this.$store.state.employee,
          this.$store.state.tasks,
          start,
          end
        );
        const times = response.data;
        this.$store.commit("times", times);
      }
    },
    login: async function() {
      localStorage.setItem("weekly-pin", this.pin);
      const stored = localStorage.getItem(`weekly-state-${this.pin}`);
      let stored_language = "en";
      let stored_company = null;
      let stored_crew = null;
      let stored_employee = null;

      if (stored) {
        const stored_object = JSON.parse(stored);

        if (stored_object.language) {
          stored_language = stored_object.language;
        }
        if (stored_object.company) {
          stored_company = stored_object.company;
        }
        if (stored_object.crew) {
          stored_crew = stored_object.crew;
        }
        if (stored_object.employee) {
          stored_employee = stored_object.employee;
        }
      }

      try {
        const response = await PinService.login(this.pin);

        response.data.language = stored_language;
        this.$store.commit("login", response.data);
      } catch (ex) {
        this.offline = true;

        // Load Vuex from local storage, as long as this is the same pin
        const stored = localStorage.getItem(`weekly-state-${this.pin}`);
        if (stored) {
          this.$store.commit("load", JSON.parse(stored));
        }
      }
      // Restore user selections from last load.
      if (stored_language) {
        this.$store.commit("language", stored_language);
      }

      if (stored_company) {
        console.log("Stored company is ");
        console.log(stored_company);
        // If the user was working on a company before, restore it - as long as it is still
        // in the company list.
        const i = this.$store.state.companies
          .map(c => c._id)
          .indexOf(stored_company._id);
        if (i >= 0) {
          this.$store.commit("company", stored_company);
        }
      }

      if (stored_crew) {
        // If the user was working on a crew before, restore it - as long as it is still
        // in the crew list.
        const i = this.$store.state.crews
          .map(c => c._id)
          .indexOf(stored_crew._id);
        if (i >= 0) {
          this.$store.commit("crew", stored_crew);
        }
      }

      if (stored_employee) {
        // If the user was working on a employee before, restore it - as long as it is still
        // in the employee list.
        const i = this.$store.state.employees
          .map(c => c._id)
          .indexOf(stored_employee._id);
        if (i >= 0) {
          this.$store.commit("employee", stored_employee);
        }
      }
      console.log("LOGGIN COMPLETE");
    }
  }
};
</script>

<style lang="less">
#login {
  background-color: #4d8298 !important;
  height: 100vh;
}

img.brand {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
nav {
  background-color: #333;
  margin-bottom: 0px !important;
}
h1 {
  color: white !important;
}
section {
  margin-top: 0.5rem;
}
.flex {
  display: flex;
}
.flex-min {
  flex-grow: 0;
}
.flex-shrink {
  flex-shrink: 2;
}
.flex-grow {
  flex-grow: 10;
}
.week-heading {
  background-color: #2c3e50;
  color: white;
  border-bottom: 2px solid lighten(#2c3e50, 20%) !important;
}
.day-column {
  border-right: 2px solid #ccc !important;
  padding: 2px !important;
}
.columns {
  margin: 0px !important;
}
.column {
  border-bottom: 2px solid lighten(#2c3e50, 20%);
}
#week-sticky {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.footer {
  padding: 0.5rem !important;

  bottom: 0px;
  .button {
    margin-bottom: 0.5rem;
  }
}
</style>
